import React, {ReactElement} from 'react'
import styled from 'styled-components'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import {CardContent, ClickAwayListener, IconButton, Popper, Tooltip} from '@mui/material';
import withStyles from '@mui/styles/withStyles';

interface Props {
    message: string
}

interface State {
    anchorEl: HTMLElement | null
    tooltipOpen: boolean;
}

export default class HintButton extends React.Component<Props, State> {

    static displayName: string = 'HintButton'

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            anchorEl: null,
            tooltipOpen: false
        }

        this.handleHintClick = this.handleHintClick.bind(this)
        this.handleTooltipClose = this.handleTooltipClose.bind(this)
    }

    handleHintClick(event: React.MouseEvent<HTMLElement>): void {
        this.setState({
            anchorEl: this.state.anchorEl ? null : event.currentTarget,
        })
    }

    handleTooltipClose(): void {
        this.setState({
            anchorEl: null,
        })
    }

    render(): ReactElement {
        const {tooltipOpen} = this.state;
        return (
            <ClickAwayListener
                onClickAway={() => {
                    if (tooltipOpen) {
                        this.setState({
                            tooltipOpen: false
                        });
                    }
                }}>
                <div>
                    <HtmlTooltip
                        open={tooltipOpen}
                        onClose={() => this.setState({tooltipOpen: false})}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title={this.props.message}
                        arrow
                        placement={'top'}
                    >

                        <IconButton
                            size={'small'}
                            color="default"
                            aria-label="hint"
                            onClick={() =>
                                this.setState(prev => ({tooltipOpen: !prev.tooltipOpen}))}
                        >
                            <HelpOutlineOutlinedIcon titleAccess={'hint'}/>
                        </IconButton>
                    </HtmlTooltip>
                </div>
            </ClickAwayListener>)
    }
}

const HtmlTooltip = withStyles({
    tooltip: {
        maxWidth: '100%',
        whiteSpace: 'pre-wrap',
        fontSize: '12px',
        backgroundColor: 'rgba(97, 97, 97, 0.9)',
        padding: '4px 8px',
        margin: 0,
    },
})(Tooltip)

const HintContent = styled(CardContent)`
  white-space: pre-wrap;
  background-color: lightgray;
  color: black;
`

const zIndexOfModal: number = 1300
const StyledPopper = styled(Popper)`
  z-index: ${zIndexOfModal};
`
